import api from './api';

const resource = 'CompanySetting/';

export const list = async (companyid) => {
  return await api.get(resource + 'List?companyid=' + companyid);
};

export const get = async (companyid, code) => {
  return await api.get(
    resource + 'Get?companyid=' + companyid + '&code=' + code
  );
};

export const create = async (body) => {
  return await api.post(resource + 'Create', body);
};

export const update = async (body) => {
  return await api.put(resource + 'Update', body);
};

export const batchCreate = async (body) => {
  return await api.post(resource + 'BatchCreate', body);
};

export const batchUpdate = async (body) => {
  return await api.put(resource + 'BatchUpdate', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

const companySettingApi = {
  list,
  get,
  create,
  update,
  batchCreate,
  batchUpdate,
  deleteById,
};

export default companySettingApi;
